import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import { ModifierTypes } from 'models/layout-mod.model';
import { StylingService } from 'shared/services/styling.service';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent<T> {
  @Input() options!: T[];

  @Input() mainForm!: UntypedFormGroup;

  @Input() controlName!: string;

  @Input() labelKey!: string;

  @Input() layoutMod: ModifierTypes[] = ['box'];

  layoutModifier = '';

  idSuffix = '';

  constructor(
    private stylingService: StylingService
  ) { }

  ngOnInit(): void {
    this.layoutModifier = this.stylingService.concatLayoutModifiers('checkboxBlock-label', this.layoutMod);
    this.idSuffix = this.mainForm && this.mainForm.value.id ? `_${this.mainForm.value.id}` : '';
  }
}
